import moment from 'moment';
import { useContext } from 'react';
import { DateTimeStamp } from '../../types/primitives/DateTimeStamp';
import { dateTimeUtils } from '../../utils';
import { useEvalSubscription } from '../eval/hooks/userEvalSubscription';
import { ActionBlockerProps } from './ActionBlocker';
import { OnHoverTooltip } from '../common';
import { BlockedFeatureContext } from './BlockedFeatureContext';

interface Props extends ActionBlockerProps {
    holidays: DateTimeStamp[]
    evalDate?: DateTimeStamp | Date
    children: (limited: boolean) => React.ReactNode
}

export const EvalTrialDataBlocker = ({ evalDate, holidays, children }: Props) => {
    const isFeatureBlocked = useContext(BlockedFeatureContext);
    const { isTrial, isTrialEnded: isTrialExpired } = useEvalSubscription();

    if (!isTrial || isTrialExpired || isFeatureBlocked) {
        return <>{children(false)}</>
    }

    const today = moment.utc();
    const lastBusinessDay = dateTimeUtils.getLastBusinessDayOfPreviousMonth(holidays);
    if (!evalDate || moment.utc(evalDate).isBetween(lastBusinessDay, today, 'day', '[]')) {
        return <>{children(false)}</>
    }

    return (
        <OnHoverTooltip overlay="In trial, data is available only for the current month and the prior month-end date">
            {children(true)}
        </OnHoverTooltip>
    );
};
